import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import {OauthService} from './oauth.service';
import {Observable} from 'rxjs/Observable';
import {Search} from '../models/search/search.model';
import {App} from 'ionic-angular';
import {Http} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class BlogThemeService extends OauthService {
  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
    this.loader.next(true);
  }

  getAll(search: Observable<Search> = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.searchAllThemes(s, s.action));
  }

  searchAllThemes(search: Search, action: string) {
    const param = {'_format': 'json'};

    if (search) {
      for (const item in search) {
        if (search[item]) {
          param[item] = search[item];
        }
      }
    }

    const url = this.Routing.generate('api_get_blog-themes', param, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false);
        return {data: response.json().data, action};
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/blogTheme.service.ts